module.exports = {
	"id": "/event_halftime",
	"type": "object",
	"properties": {
		"sportId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"eventId": {
			"type": "integer",
			"required": true
		},
		"minutes": {
			"type": "integer",
			"required": true
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/event_halftime.json
 ** module id = 1829
 ** module chunks = 0
 **/